import RetirementOfPeriodRequestRepository from '../../domain/repositories/RetirementOfPeriodRequestRepository';
import RetirementOfPeriodRequestDataStore from '../datastores/RetirementOfPeriodRequestDataStore';
import RetirementOfPeriodRequestDataStoreFactory from '../factories/RetirementOfPeriodRequestDataStoreFactory';

export default class RetirementOfPeriodRequestDataRepository
  implements RetirementOfPeriodRequestRepository
{
  register(data: {
    procedureId: number;
    reason: string;
    detail: string;
    contact: string;
    idDetail2: number;
    detail2: string;
    period: string;
    career?: string;
  }) {
    const retirementOfPeriodRequestDataStore: RetirementOfPeriodRequestDataStore =
      RetirementOfPeriodRequestDataStoreFactory.create();
    return retirementOfPeriodRequestDataStore.register(data);
  }
}
